import React from "react";
var __jsx = React.createElement;
import Icons from "@modules/icons";
import { downloadDocType } from "@lib/util/link-redirection-ops";
import { DocumentType } from "types/document-type";
import { useTranslations } from "next-intl";
import useCssModules from "@lib/hooks/use-css-modules";
export default function About() {
  var _cssModules$footers$f;
  const t = useTranslations("Shared.Layout");
  const {
    cssModules
  } = useCssModules();
  const {
    aboutContainerClassNames,
    aboutInfoContainerClassNames,
    aboutInfoItemContainerClassNames,
    aboutInfoItemTextClassNames,
    aboutInfoItemIconClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerInterbank) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx("div", {
    className: aboutContainerClassNames
  }, __jsx("div", {
    className: aboutInfoContainerClassNames
  }, __jsx("a", {
    className: aboutInfoItemContainerClassNames,
    href: "https://www.interbankbenefit.pe/que-es-interbank-benefit"
  }, Icons.contact && __jsx(Icons.contact, {
    className: aboutInfoItemIconClassNames
  }), __jsx("span", {
    className: aboutInfoItemTextClassNames
  }, t("ABOUT_US"))), __jsx("a", {
    className: aboutInfoItemContainerClassNames,
    onClick: () => downloadDocType(DocumentType.TERMS_AND_CONDITIONS)
  }, Icons.terms && __jsx(Icons.terms, {
    className: aboutInfoItemIconClassNames
  }), __jsx("span", {
    className: aboutInfoItemTextClassNames
  }, t("TERMS_AND_CONDITIONS"))), __jsx("a", {
    className: aboutInfoItemContainerClassNames,
    onClick: () => downloadDocType(DocumentType.PRIVACY_POLICY)
  }, Icons.privacy && __jsx(Icons.privacy, {
    className: aboutInfoItemIconClassNames
  }), __jsx("span", {
    className: aboutInfoItemTextClassNames
  }, t("PRIVACY_POLICY")))));
}